import { Container, Row, Col, Button, Form, Alert, Card, ProgressBar, Modal, Spinner } from 'react-bootstrap';
import React, { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getActiveCategories } from '../../services/categories';
import { getActiveSubcategories } from '../../services/subcategories';
import { saveDraftNews, getNewsById, updateNews,autoUpdateNews, uploadFiles } from '../../services/news';
import Loading from '../../components/layout/Loading';
import { getStatuses } from '../../services/statuses'
import FilesContainerEdit from '../../components/news/FilesContainerEdit'
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { getSections } from "../../services/sections";


// Ajusta estos valores según la configuración del servidor.
const MAX_UPLOAD_MB = 20;
const ACCEPTED_MIME_PREFIXES = ['image/', 'video/'];
const ACCEPTED_FORMATS_LABEL = 'Imágenes (JPG, PNG, WebP, GIF, etc.) y videos';

function AddAndEditNews() {
    const navigate = useNavigate();
    const [sections, setSections] = useState(false);
    const [isUploadingFiles, setIsUploadingFiles] = useState(false);
    const [uploadFilesResult, setUploadFilesResult] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [editorContent, setEditorContent] = useState('');
    const [statuses, setStatuses] = useState([]);
    const [reloadFilesContainer, setReloadFilesContainer] = useState(false);
    const [filesQty, setFilesQty] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(false);
    const [showEmbedWarning, setShowEmbedWarning] = useState(false);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [invalidFields, setInvalidFields] = useState(new Set());
    const [uploadSizeError, setUploadSizeError] = useState(null);
    const [uploadFormatErrors, setUploadFormatErrors] = useState([]);
    const [uploadSizeMB, setUploadSizeMB] = useState(0);

    let id = 0;
    if (localStorage.getItem('news_id') == null || localStorage.getItem('news_id') == undefined) {
        id = 0;
    } else {
        id = parseInt(localStorage.getItem('news_id'));
    }

    const saveDraft = () => {
        const { errors, invalid } = validateForm(form, false);
        if (errors.length > 0) {
            setValidationErrors(errors);
            setInvalidFields(invalid);
            setShowValidationModal(true);
            return;
        }
        setInvalidFields(new Set());
        setIsLoading(true);
        saveDraftNews(form).then((data) => {
            setForm({
                ...form,
                ["id"]: data.id,
            });
            setIsLoading(false);
        })
    }

    const loadDataToForm = (data) => {
        setForm((prevForm) => {
            if (JSON.stringify(prevForm) === JSON.stringify(data)) {
                return prevForm; // Evita re-render si no hay cambios
            }
            return {
                ...prevForm,
                id: id,
                title: data.title,
                social_title: data.social_title,
                short_description: data.short_description,
                description: data.description,
                descriptionJson: data.descriptionJson,
                descriptionHtml: data.descriptionHtml,
                category_id: data.category_id,
                subcategory_id: data.subcategory_id,
                embedded_code: data.embedded_code,
                status_id: data.status_id,
                scheduled_at: data.scheduled_at_input,
                scheduled_at_section_id: data.scheduled_at_section_id
            };
        });

        setTimeout(() => {
            setEditorContent(data.descriptionHtml || (data.description ? `<p>${data.description}</p>` : ''));
        }, 500);
    };

    const toolbarOptions = [
        ['link'],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean']
    ];

    const [form, setForm] = useState({
        id: id,
        title: '',
        social_title: '',
        short_description: '',
        description: '',
        descriptionJson: '',
        descriptionHtml: '',
        category_id: 0,
        subcategory_id: 0,
        embedded_code: '',
        status_id: 0,
        scheduled_at: null,
        scheduled_at_section_id:0
    });

    // Recibe currentForm y currentFilesQty explícitamente para evitar cualquier
    // problema de closure. function declaration → se hoista, disponible en todo el scope.
    function validateForm(currentForm, forUpdate = false) {
        const errors = [];
        const invalid = new Set();

        if (!currentForm.title || currentForm.title.trim() === '') {
            errors.push('Título: este campo es obligatorio');
            invalid.add('title');
        }

        if (!currentForm.category_id || parseInt(currentForm.category_id) === 0) {
            errors.push('Categoría: debes seleccionar una categoría');
            invalid.add('category_id');
        }

        if (forUpdate) {
            const hasContent = currentForm.description && currentForm.description.trim() !== '';
            const hasEmbed = currentForm.embedded_code && currentForm.embedded_code.trim() !== '';

            if (parseInt(currentForm.status_id) === 4 || parseInt(currentForm.status_id) === 6) {
                if (!hasContent && !hasEmbed) {
                    errors.push('Nota: el cuerpo de la nota está vacío — agrega texto o un código embebido');
                    invalid.add('description');
                }
                if (filesQty === 0) {
                    errors.push('Multimedia: debes agregar al menos una imagen para publicar o programar');
                    invalid.add('files');
                }
            }

            if (parseInt(currentForm.status_id) === 6) {
                if (!currentForm.scheduled_at || currentForm.scheduled_at.trim() === '') {
                    errors.push('Fecha programada: debes seleccionar una fecha y hora');
                    invalid.add('scheduled_at');
                }
            }
        }

        return { errors, invalid };
    }

    const updateFilesQty = (qty) => {
        setFilesQty(qty);
    };

    const redirectHome = () => {
        navigate('/');
    };

    const handleEditorChange = (content, delta, source, editor) => {
        const plainText = editor.getText();
        setEditorContent(content);
        setForm({
            ...form,
            description: plainText,
            descriptionHtml: content
        });
    };

    const handleDateChange = (e) => {
        const localDate = e.target.value;
        setForm({
            ...form,
            scheduled_at: localDate
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Auto-limpia el error visual en cuanto el campo tiene valor válido
        if (invalidFields.has(name)) {
            const isEmpty = name === 'category_id' ? parseInt(value) === 0 : !value || value.trim() === '';
            if (!isEmpty) {
                setInvalidFields(prev => {
                    const next = new Set(prev);
                    next.delete(name);
                    return next;
                });
            }
        }

        if(name == "category_id")
        {
            setForm({
                ...form,
                [name]: value,
                ["subcategory_id"]: 0,
            })
        }
        else if (name === "embedded_code") {
            setForm({
                ...form,
                [name]: value,
            });

            if (value.trim() !== "" && filesQty === 0) {
                setShowEmbedWarning(true);
            } else {
                setShowEmbedWarning(false);
            }
        } else {
            setForm({
                ...form,
                [name]: value,
            });
        }
    };

    const handleBlurRequired = (e) => {
        const { name, value } = e.target;
        const isEmpty = name === 'category_id' ? parseInt(value) === 0 : !value || value.trim() === '';
        setInvalidFields(prev => {
            const next = new Set(prev);
            if (isEmpty) next.add(name);
            else next.delete(name);
            return next;
        });
    };

    const handleFileChange = (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        // Validar formatos
        const invalidFiles = Array.from(files).filter(
            f => !ACCEPTED_MIME_PREFIXES.some(prefix => f.type.startsWith(prefix))
        );
        if (invalidFiles.length > 0) {
            setUploadFormatErrors(invalidFiles.map(f => `"${f.name}" (${f.type || 'tipo desconocido'})`));
            e.target.value = '';
            return;
        }
        setUploadFormatErrors([]);

        // Validar peso total
        const totalBytes = Array.from(files).reduce((sum, f) => sum + f.size, 0);
        const totalMB = totalBytes / (1024 * 1024);

        if (totalMB > MAX_UPLOAD_MB) {
            setUploadSizeError(
                `Seleccionaste ${totalMB.toFixed(1)} MB pero el límite por envío es ${MAX_UPLOAD_MB} MB. ` +
                `Sube las imágenes en grupos más pequeños.`
            );
            e.target.value = '';
            return;
        }

        setUploadSizeError(null);
        setUploadSizeMB(totalMB);
        setIsUploadingFiles(true);
        const data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append(`file${i}`, files[i]);
        }

        uploadFiles(data, form.id)
            .then((result) => {
                setIsUploadingFiles(false);
                setUploadFilesResult(result.success);
                setReloadFilesContainer(!reloadFilesContainer);

                if (result.success) {
                    toast.success("Los archivos se han subido exitosamente.");
                } else {
                    toast.error("Hubo un problema al subir los archivos.");
                }
            })
            .catch(() => {
                setIsUploadingFiles(false);
                setUploadFilesResult(false);
                toast.error("Hubo un problema al subir los archivos.");
            });
    };

    const onUpdateNews = () => {
        const { errors, invalid } = validateForm(form, true);
        if (errors.length > 0) {
            setValidationErrors(errors);
            setInvalidFields(invalid);
            setShowValidationModal(true);
            return;
        }
        setInvalidFields(new Set());
        updateNews(form).then((result) => {
            if (result.success) {
                toast.success("Se actualizó correctamente");
            } else {
                toast.error("Algo salió mal");
            }
        });
    };

    useEffect(() => {
        if (parseInt(form.category_id) !== 0) {
            getActiveSubcategories(parseInt(form.category_id)).then((data) => {
                setSubcategories(data);
            });
        } else {
            setSubcategories([]);
        }
    }, [form.category_id]);

    useEffect(() => {
        getStatuses().then((data) => setStatuses(data));
        getActiveCategories().then((data) => setCategories(data));
        if (id !== 0) {
            getSections().then((list) => setSections(list));
            getNewsById(id).then((data) => {
                if (data.subcategory_id !== null && data.subcategory_id !== 0) {
                    getActiveSubcategories(parseInt(form.category_id)).then((data) => {
                        setSubcategories(data);
                    }).finally(() => {
                        loadDataToForm(data);
                    });
                } else {
                    loadDataToForm(data);
                }
            });
        }
    }, []);

    useEffect(() => {
        if (form.id !== 0) {
        getSections().then((list) => setSections(list));
        }
    }, [form.id]);

    return (<>
        <Container fluid className='mb-5 px-4'>

            {/* ===== FILA 1: contenido + multimedia ===== */}
            <Row className='mt-3 justify-content-center align-items-stretch'>

                {/* Columna contenido */}
                <Col xl={form.id != 0 ? 7 : 8} lg={12}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold">
                                {id === 0 ? 'Nueva nota' : 'Editar nota'}
                            </span>
                            {id !== 0 && (
                                <span className="badge bg-secondary fs-6">ID: {id}</span>
                            )}
                        </Card.Header>
                        <Card.Body>

                            {/* Título */}
                            <Form.Group className="mb-3">
                                <Form.Label>Título <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    id='title'
                                    name='title'
                                    placeholder='Escribe el título de la nota...'
                                    value={form.title}
                                    onChange={handleInputChange}
                                    onBlur={handleBlurRequired}
                                    isInvalid={invalidFields.has('title')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    El título es obligatorio.
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Título Social + Sumario en la misma fila */}
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Título Social</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id='social_title'
                                            name='social_title'
                                            placeholder='Para redes sociales'
                                            value={form.social_title}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Sumario</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id='short_description'
                                            name='short_description'
                                            placeholder='Descripción corta'
                                            value={form.short_description}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Editor Quill */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Nota
                                    {invalidFields.has('description') && (
                                        <span className="text-danger ms-2" style={{ fontSize: '0.85rem', fontWeight: 'normal' }}>
                                            ⚠ El cuerpo de la nota está vacío
                                        </span>
                                    )}
                                </Form.Label>
                                <div
                                    className="ql-editor-tall"
                                    style={invalidFields.has('description') ? { border: '2px solid #dc3545', borderRadius: '4px' } : {}}
                                >
                                    <ReactQuill
                                        value={editorContent}
                                        onChange={handleEditorChange}
                                        modules={{ toolbar: toolbarOptions }}
                                        theme="snow"
                                        placeholder="Escribe la nota aquí..."
                                    />
                                </div>
                            </Form.Group>

                            {/* Código embebido */}
                            <Form.Group>
                                <Form.Label>Código para embebidos</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    id='embedded_code'
                                    name='embedded_code'
                                    placeholder='Pega aquí el código embebido (iframe, script, etc.)'
                                    onChange={handleInputChange}
                                    value={form.embedded_code}
                                    rows={3}
                                />
                            </Form.Group>
                            {showEmbedWarning && (
                                <Alert variant="warning" className="mt-2">
                                    Has agregado un código embebido, pero no hay imágenes en la nota.
                                    Agrega al menos una imagen para asegurar que se muestre correctamente en la portada o en su sección.
                                </Alert>
                            )}

                        </Card.Body>
                    </Card>
                </Col>

                {/* Columna multimedia — solo en edición, sticky con scroll interno */}
                {form.id != 0 && (
                    <Col xl={4} lg={12} className="mt-3 mt-xl-0 ps-xl-3">
                        <Card className="h-100" border={invalidFields.has('files') ? 'danger' : undefined}>
                            <Card.Header className={`fw-semibold${invalidFields.has('files') ? ' bg-danger text-white' : ''}`}>
                                Multimedia
                                {invalidFields.has('files') && (
                                    <span className="ms-2">⚠ Se requiere al menos una imagen</span>
                                )}
                            </Card.Header>
                            <Card.Body className="d-flex flex-column">
                                <Form.Group className="mb-2">
                                    <Form.Label>Selecciona archivos</Form.Label>
                                    <Form.Control
                                        type="file"
                                        multiple
                                        accept="image/*,video/*"
                                        onChange={handleFileChange}
                                    />
                                    <Form.Text className="text-muted">
                                        <strong>Formatos:</strong> {ACCEPTED_FORMATS_LABEL}<br />
                                        <strong>Máx. por envío:</strong> {MAX_UPLOAD_MB} MB
                                    </Form.Text>
                                </Form.Group>
                                {uploadFormatErrors.length > 0 && (
                                    <Alert variant="danger" className="mt-2">
                                        <strong>Formato no permitido:</strong>
                                        <ul className="mb-0 mt-1">
                                            {uploadFormatErrors.map((name, i) => (
                                                <li key={i}>{name}</li>
                                            ))}
                                        </ul>
                                    </Alert>
                                )}
                                {uploadSizeError && (
                                    <Alert variant="warning" className="mt-2">
                                        <strong>⚠ Límite excedido</strong><br />{uploadSizeError}
                                    </Alert>
                                )}
                                {isUploadingFiles && (
                                    <div className="mt-2 p-3 rounded border border-primary-subtle bg-primary-subtle">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <Spinner animation="border" variant="primary" size="sm" />
                                            <span className="fw-semibold text-primary" style={{ fontSize: '0.9rem' }}>
                                                Subiendo archivos...
                                            </span>
                                            <span className="text-muted ms-auto" style={{ fontSize: '0.8rem' }}>
                                                {uploadSizeMB.toFixed(1)} MB
                                            </span>
                                        </div>
                                        <ProgressBar animated striped variant="primary" now={100} style={{ height: '6px' }} />
                                        {uploadSizeMB > MAX_UPLOAD_MB * 0.6 && (
                                            <p className="mb-0 mt-2 text-muted" style={{ fontSize: '0.78rem' }}>
                                                ⏳ Esto puede tardar un momento, no cierres la página.
                                            </p>
                                        )}
                                    </div>
                                )}
                                {uploadFilesResult === true && (
                                    <Alert variant="success" className="mt-2">
                                        Los archivos se han subido exitosamente.
                                    </Alert>
                                )}
                                {uploadFilesResult === false && (
                                    <Alert variant="danger" className="mt-2">
                                        Hubo un error al subir los archivos.
                                    </Alert>
                                )}
                                <FilesContainerEdit
                                    news_id={form.id}
                                    reloadFilesContainer={reloadFilesContainer}
                                    onUpdateFilesQty={updateFilesQty}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                )}

            </Row>

            {/* ===== FILA 2: publicación — ancho completo ===== */}
            <Row className='mt-3 justify-content-center'>
                <Col xl={form.id != 0 ? 11 : 8} lg={12}>
                    <Card>
                        <Card.Header className="fw-semibold">Publicación</Card.Header>
                        <Card.Body>

                            {/* Checklist en vivo */}
                            {(() => {
                                const isPublishOrSchedule = parseInt(form.status_id) === 4 || parseInt(form.status_id) === 6;
                                const checks = [
                                    { ok: form.title?.trim(), label: 'Título' },
                                    { ok: parseInt(form.category_id) !== 0, label: 'Categoría' },
                                    ...(form.id !== 0 && isPublishOrSchedule ? [
                                        { ok: form.description?.trim() || form.embedded_code?.trim(), label: 'Contenido' },
                                        { ok: filesQty > 0, label: 'Multimedia' },
                                    ] : []),
                                    ...(parseInt(form.status_id) === 6 ? [
                                        { ok: form.scheduled_at?.trim(), label: 'Fecha programada' },
                                    ] : []),
                                ];
                                const allOk = checks.every(c => c.ok);
                                return (
                                    <ul className="list-unstyled d-flex flex-wrap gap-3 mb-3 px-2 py-2 rounded" style={{ background: allOk ? '#d1e7dd' : '#fff3cd', fontSize: '0.82rem' }}>
                                        {checks.map(({ ok, label }) => (
                                            <li key={label} style={{ color: ok ? '#0f5132' : '#856404', fontWeight: ok ? 'normal' : '600' }}>
                                                {ok ? '✓' : '!'} {label}
                                            </li>
                                        ))}
                                    </ul>
                                );
                            })()}

                            {/* Campos en fila horizontal */}
                            <Row className="align-items-end">
                                <Col md={3} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>Categoría <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="category_id"
                                            value={form.category_id}
                                            onChange={handleInputChange}
                                            onBlur={handleBlurRequired}
                                            isInvalid={invalidFields.has('category_id')}
                                        >
                                            <option key={0} value={0}>Seleccionar categoría</option>
                                            {categories.map((category) => (
                                                <option key={category.id} value={category.id}>{category.name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            Selecciona una categoría.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                <Col md={3} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>Subcategoría</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="subcategory_id"
                                            value={form.subcategory_id}
                                            onChange={handleInputChange}
                                        >
                                            <option key={0} value={0}>Seleccionar subcategoría</option>
                                            {subcategories.map((category) => (
                                                <option key={category.id} value={category.id}>{category.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                {form.id !== 0 && (
                                    <Col md={2} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Status <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="status_id"
                                                value={form.status_id}
                                                onChange={handleInputChange}
                                            >
                                                {statuses.map((status) => (
                                                    <option key={status.id} value={status.id}>{status.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                )}

                                <Col md={form.id !== 0 ? 4 : 6} className="mb-3">
                                    {isLoading ? <Loading /> : (
                                        <div className="d-flex gap-2 justify-content-end">
                                            {form.id == 0 ? (
                                                <Button variant='success' size="lg" onClick={saveDraft}>
                                                    Guardar borrador
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant='success'
                                                    size="lg"
                                                    disabled={isAutoSaving}
                                                    onClick={onUpdateNews}
                                                >
                                                    {isAutoSaving ? 'Actualizando...' : 'Actualizar'}
                                                </Button>
                                            )}
                                            <Button variant='outline-secondary' size="lg" onClick={redirectHome}>
                                                Cancelar
                                            </Button>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            {/* Programación — solo si status == 6 */}
                            {form.id !== 0 && form.status_id == 6 && (
                                <Row>
                                    <Col md={4} className="mb-2">
                                        <Form.Group>
                                            <Form.Label>Fecha y hora de publicación</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                value={form.scheduled_at}
                                                onChange={handleDateChange}
                                                isInvalid={invalidFields.has('scheduled_at')}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                La fecha y hora son obligatorias para programar.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} className="mb-2">
                                        <Form.Group>
                                            <Form.Label>¿A qué portada va?</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="scheduled_at_section_id"
                                                value={form.scheduled_at_section_id}
                                                onChange={handleInputChange}
                                            >
                                                <option key={0} value={0}>No mandar a ninguna portada</option>
                                                {sections && sections.length > 0 ?
                                                    sections.map((section) => (
                                                        <option key={section.id} value={section.id}>{section.name}</option>
                                                    )) : null
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            {/* Info cuando no es programado */}
                            {form.id !== 0 && form.status_id != 6 && (
                                <Alert variant="info" className="py-2 mb-0">
                                    <small>Para publicar Online asegúrate de incluir al menos un elemento multimedia (imagen, video o embebido).</small>
                                </Alert>
                            )}

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </Container>

        {/* Modal de validación — imposible de ignorar */}
        <Modal
            show={showValidationModal}
            onHide={() => setShowValidationModal(false)}
            centered
            backdrop="static"
        >
            <Modal.Header closeButton style={{ backgroundColor: '#dc3545', color: '#fff' }}>
                <Modal.Title>
                    ⚠️ Faltan campos obligatorios
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3 fw-bold">
                    No se puede guardar la nota. Corrige los siguientes campos:
                </p>
                <ul className="mb-0" style={{ paddingLeft: '1.2rem' }}>
                    {validationErrors.map((error, index) => (
                        <li key={index} style={{ color: '#dc3545', fontWeight: '600', marginBottom: '0.4rem' }}>
                            {error}
                        </li>
                    ))}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" size="lg" onClick={() => setShowValidationModal(false)}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>

        <ToastContainer position="top-center" />
    </>)
}


export default AddAndEditNews;
